import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { Icon, usePageMeta, PageHero, FinalCTA } from "../components/Shared";
import { SERVICES, IMAGES } from "../data/site";

export default function Services() {
  usePageMeta("Services", "Cross-docking, short-term warehousing, pallet transfers, freight sorting, rework, LTL pickup-and-delivery and appointment scheduling in Mississauga and the GTA.");
  return (
    <>
      <PageHero eyebrow="Our Services" image={IMAGES.warehouse}
        title="Freight Services, Handled Right"
        subtitle="From cross-docking to LTL pickup-and-delivery, every service is built to keep your freight moving safely and on schedule." />

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {SERVICES.map((s, i) => (
            <StaggerItem key={s.slug}>
              <div id={s.slug} data-testid={`service-${s.slug}`}
                   className="group bg-white p-8 lg:p-10 h-full flex flex-col scroll-mt-28 hover:bg-navy transition-colors duration-300">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 flex items-center justify-center bg-navy text-orange group-hover:bg-orange group-hover:text-white transition-colors">
                    <Icon name={s.icon} size={24} strokeWidth={1.5} />
                  </div>
                  <span className="font-mono text-xs text-gray-300 group-hover:text-white/30 transition-colors">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h2 className="font-display font-bold text-xl mt-6 group-hover:text-white transition-colors">{s.title}</h2>
                <p className="mt-3 text-sm text-text-secondary leading-relaxed group-hover:text-white/60 transition-colors flex-1">
                  {s.short}
                </p>
                <Link to={`/quote?service=${encodeURIComponent(s.title)}`} data-testid={`request-service-${s.slug}`}
                      className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-orange">
                  Request This Service
                  <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
      <FinalCTA />
    </>
  );
}
